<p-tabView scrollable="true">
  <p-tabPanel header="{{docType.DOCTYPEID}}" tooltip="{{docType.DOCNAME}}" [cache]="false" *ngFor="let docType of docTypes">
    <app-edit-doc-type-item [docType]="docType"></app-edit-doc-type-item>
  </p-tabPanel>
</p-tabView>
